<div class="card h-100">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="card-title mb-0 text-truncate flex-grow-1 me-2"><%= pack.name %></h5>
        <% if ( pack.status === 'ACTIVE' ) { %>
            <span class="badge bg-success-subtle text-success">Active</span>
        <% } else { %>
            <span class="badge bg-warning-subtle text-warning">Inactive</span>
        <% } %>
    </div>
    <div class="card-body d-flex flex-column">

        <div>
            <div class="mb-3">
                <label class="form-label text-muted text-uppercase fw-bold detail-label mb-0">ID</label>
                <p class="mb-0 small text-truncate" title="<%= pack.id %>"><pre><%= pack.id %></pre></p>
            </div>

            <div class="row g-2">
                <div class="col-6">
                    <label class="form-label text-muted text-uppercase fw-bold detail-label mb-0">Created</label>
                    <p class="mb-0 small"><%= createdAt %></p>
                </div>
                <div class="col-6">
                    <label class="form-label text-muted text-uppercase fw-bold detail-label mb-0">Updated</label>
                    <p class="mb-0 small"><%= updatedAt %></p>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer d-flex align-items-center gap-2">
        <button type="button"
                data-type="pack-card-delete"
                class="btn btn-outline-danger">
            <i class="ti ti-trash"></i>
        </button>
        <% if ( pack.status === 'ACTIVE' ) { %>
        <button type="button"
                data-type="pack-card-toggle-status"
                class="btn btn-outline-warning">
            <i class="ti ti-player-pause"></i>
        </button>
        <% } else { %>
        <button type="button"
                data-type="pack-card-toggle-status"
                class="btn btn-outline-success">
            <i class="ti ti-player-play"></i>
        </button>
        <% } %>
        <a href="/pack/view/<%= pack.id %>" class="btn btn-primary ms-auto">
            <i class="ti ti-eye me-1"></i>Details
        </a>
    </div>
</div>
